import { useAccessibleOrganizations } from "src/api/queries";
import { TAKTILE_ORG_ID } from "src/constants/OrgIds";

export const useIsTaktileOrgUser = (): boolean => {
  const accessibleOrganizationsResult = useAccessibleOrganizations();
  return (
    accessibleOrganizationsResult.data?.some(
      (org) => org.id === TAKTILE_ORG_ID,
    ) ?? false
  );
};
